// Other names for each exercise, so search and the import matcher find it: English synonyms, common abbreviations
// (KB, DB, BB, RDL, OHP, TGU) and common German names in ASCII (ae, oe, ue, ss for umlauts and sharp s).
// Merged with the aliases written next to each exercise. A test checks that no alias points to two exercises
// and that every exercise has at least one.
export const ALIASES: Record<string, string[]> = {
  // Starter
  kettlebell_swing: ['KB swing', 'Swing', 'Kettlebell Schwung', 'Kettlebell Swing beidhaendig'],
  goblet_squat_press: ['Goblet squat and press', 'Goblet thruster', 'Goblet Kniebeuge mit Druecken'],
  renegade_row: ['KB renegade row', 'Plank row', 'Renegade Rudern'],
  kettlebell_deadlift: ['KB deadlift', 'Kettlebell Kreuzheben'],
  reverse_lunge_curl: ['Reverse lunge to curl', 'Lunge with biceps curl', 'Ausfallschritt rueckwaerts mit Curl'],
  squat: ['Squats', 'Kniebeuge', 'Freie Kniebeuge', 'Bodyweight Kniebeuge'],
  push_up: ['Press-up', 'Pushup', 'Liegestuetz'],
  plank: ['Forearm plank', 'Elbow plank', 'Unterarmstuetz', 'Brett'],
  single_leg_squat: ['Pistol', 'One-leg squat', 'Einbeinige Kniebeuge', 'Pistol Squat Kniebeuge'],
  lying_leg_lowers: ['Leg lowers', 'Lying leg raise', 'Beinsenken', 'Beinheben liegend'],
  superman: ['Prone back extension', 'Superman Uebung', 'Rueckenstrecker am Boden'],
  glute_bridge: ['Bruecke', 'Hip bridge', 'Bridge', 'Glute Bridge', 'Beckenheben', 'Huefte heben'],
  arm_circles: ['Arm rotations', 'Armkreisen'],
  hip_flexor_hamstring_stretch: ['Runner stretch', 'Half split stretch', 'Hueftbeuger und Beinbeuger Dehnung'],
  cat_cow: ['Cat cow stretch', 'Katze Kuh', 'Katzenbuckel'],
  downward_dog: ['Down dog', 'Downward facing dog', 'Herabschauender Hund'],
  pigeon_stretch: ['Pigeon pose', 'Taube', 'Tauben Dehnung'],
  standing_quad_stretch: ['Quad stretch', 'Oberschenkel Dehnung stehend', 'Quadrizeps Dehnung'],
  puppy_pose: ['Extended puppy pose', 'Welpen Pose', 'Hundewelpe'],
  deep_breathing: ['Slow breathing', 'Tiefes Atmen', 'Atemuebung'],

  // Bodyweight
  sumo_squat: ['Sumo Kniebeuge', 'Breite Kniebeuge'],
  prisoner_squat: ['Hands behind head squat', 'Prisoner Kniebeuge'],
  pause_squat: ['Paused squat', 'Kniebeuge mit Pause'],
  cossack_squat: ['Kosaken Kniebeuge', 'Seitliche Kniebeuge'],
  wall_sit: ['Wall squat hold', 'Chair pose against wall', 'Wandsitzen', 'Stuhl an der Wand'],
  shrimp_squat: ['Shrimp', 'Garnelen Kniebeuge'],
  box_pistol: ['Box pistol', 'Pistol to box', 'Einbeinige Kniebeuge auf Box'],
  sissy_squat: ['Sissy Kniebeuge'],
  reverse_lunge: ['Back lunge', 'Step-back lunge', 'Ausfallschritt rueckwaerts'],
  forward_lunge: ['Lunge', 'Front lunge', 'Lunges', 'Ausfallschritt', 'Ausfallschritt vorwaerts'],
  walking_lunge: ['Lunge walk', 'Gehende Ausfallschritte'],
  lateral_lunge: ['Ausfallschritt seitlich', 'Seitlicher Ausfallschritt'],
  curtsy_lunge: ['Curtsy squat', 'Knicks Ausfallschritt', 'Hofknicks'],
  split_squat: ['Split Kniebeuge', 'Ausfallschritt statisch'],
  bulgarian_split_squat: ['BSS', 'Bulgarian squat', 'Bulgarische Kniebeuge', 'Bulgarian Split Squat Kniebeuge'],
  step_up: ['Box step-up', 'Aufsteiger', 'Step-up auf Box'],
  single_leg_glute_bridge: ['One-leg glute bridge', 'Single-leg hip bridge', 'Einbeiniges Beckenheben'],
  hip_thrust_bodyweight: ['Bodyweight hip thrust on bench', 'Hip Thrust ohne Gewicht'],
  single_leg_rdl: ['Single-leg RDL', 'SL RDL', 'Einbeiniges rumaenisches Kreuzheben', 'Standwaage'],
  good_morning_bodyweight: ['Good morning without weight', 'Guten Morgen Uebung'],
  nordic_curl: ['Nordic curl', 'Nordics', 'Nordic Hamstring Curl Beinbeuger'],
  donkey_kick: ['Glute kickback on all fours', 'Esel Kick', 'Kickback im Vierfuesslerstand'],
  fire_hydrant: ['Hip abduction on all fours', 'Hydrant', 'Hydranten Uebung'],
  side_lying_leg_raise: ['Side leg raise', 'Lying hip abduction', 'Seitliches Beinheben'],
  frog_pump: ['Frog bridge', 'Frosch Beckenheben'],
  clamshell: ['Clams', 'Clam shell', 'Muschel', 'Clamshell Uebung'],
  calf_raise: ['Standing calf raise', 'Heel raise', 'Wadenheben'],
  single_leg_calf_raise: ['One-leg calf raise', 'Einbeiniges Wadenheben'],
  knee_push_up: ['Kneeling push-up', 'Modified push-up', 'Liegestuetz auf Knien', 'Knie Liegestuetz'],
  wall_push_up: ['Wall press-up', 'Liegestuetz an der Wand', 'Wand Liegestuetz'],
  incline_push_up: ['Elevated push-up', 'Incline press-up', 'Erhoehter Liegestuetz', 'Liegestuetz erhoeht'],
  decline_push_up: ['Feet-elevated push-up', 'Decline press-up', 'Liegestuetz mit erhoehten Fuessen'],
  diamond_push_up: ['Triangle push-up', 'Triceps push-up', 'Diamant Liegestuetz', 'Enger Liegestuetz'],
  wide_push_up: ['Wide-grip push-up', 'Breiter Liegestuetz'],
  pike_push_up: ['Pike press', 'Pike Liegestuetz', 'Schulter Liegestuetz'],
  handstand_push_up: ['HSPU', 'Handstand push-up', 'Handstand Liegestuetz'],
  archer_push_up: ['Archer press-up', 'Bogenschuetzen Liegestuetz'],
  hindu_push_up: ['Dand', 'Hindu Liegestuetz'],
  spiderman_push_up: ['Spider push-up', 'Spiderman Liegestuetz'],
  clap_push_up: ['Plyo push-up', 'Clapping push-up', 'Klatsch Liegestuetz'],
  bench_dip: ['Triceps dip on bench', 'Bank Dips', 'Trizeps Dips an der Bank'],
  plank_to_push_up: ['Plank up-down', 'Unterarmstuetz zu Liegestuetz'],
  shoulder_tap: ['Plank shoulder tap', 'Shoulder taps', 'Schulter Tippen im Stuetz'],
  table_row: ['Under-table row', 'Rudern unter dem Tisch'],
  prone_y_raise: ['Y raise', 'Lying Y', 'Y Heben in Bauchlage'],
  reverse_snow_angel: ['Prone snow angel', 'Schneeengel in Bauchlage'],
  bird_dog: ['Quadruped arm and leg raise', 'Vierfuesslerstand Arm Bein heben', 'Bird Dog Uebung'],
  inchworm: ['Walkout', 'Hand walkout', 'Raupe', 'Inchworm Uebung'],
  get_up_sit_down: ['Sit to stand from floor', 'Aufstehen vom Boden'],
  bear_crawl: ['Bear walk', 'Baerengang', 'Baerenkriechen'],
  crab_walk: ['Crab crawl', 'Krebsgang'],

  // Core
  side_plank: ['Side bridge', 'Seitstuetz', 'Seitlicher Unterarmstuetz'],
  high_plank: ['Push-up position hold', 'Plank on hands', 'Liegestuetz halten', 'Hoher Stuetz'],
  hollow_hold: ['Hollow body', 'Hollow rock hold', 'Hollow Body Halten', 'Schiffchen auf dem Ruecken'],
  arch_hold: ['Arch body hold', 'Superman halten', 'Bogenspannung'],
  boat_hold: ['Boat pose', 'Navasana', 'Boot', 'Boot Haltung'],
  l_sit: ['L-sit hold', 'L Sitz', 'L-Stuetz'],
  dead_bug_hold: ['Dead bug isometric', 'Toter Kaefer halten'],
  plank_with_reach: ['Plank reach', 'Plank arm reach', 'Unterarmstuetz mit Armstrecken'],
  copenhagen_plank: ['Copenhagen adductor plank', 'Copenhagen', 'Kopenhagener Seitstuetz'],
  crunch: ['Crunches', 'Ab crunch', 'Bauchpresse', 'Crunch Bauch'],
  sit_up: ['Situp', 'Full sit-up', 'Situps', 'Rumpfbeuge', 'Sit-up Bauch'],
  butterfly_sit_up: ['Butterfly situp', 'Schmetterling Sit-up'],
  bicycle_crunch: ['Bicycles', 'Bicycle', 'Fahrrad Crunch', 'Radfahren liegend'],
  dead_bug: ['Deadbug', 'Toter Kaefer'],
  reverse_crunch: ['Hip raise crunch', 'Umgekehrter Crunch', 'Reverse Crunch Bauch'],
  flutter_kicks: ['Flutters', 'Beinflattern', 'Flutter Kicks Bauch'],
  scissor_kicks: ['Scissors', 'Scherenbeine', 'Schere'],
  v_up: ['V-sit up', 'Jackknife', 'Klappmesser', 'V-Up Bauch'],
  tuck_up: ['Seated tuck', 'Knee tuck crunch', 'Knie zur Brust sitzend'],
  russian_twist: ['Seated twist', 'Russischer Twist', 'Russian Twist Bauch'],
  heel_taps: ['Alternating heel touches', 'Heel touch', 'Fersen tippen'],
  windshield_wipers: ['Lying windshield wipers', 'Scheibenwischer'],
  side_plank_hip_dip: ['Side plank dips', 'Seitstuetz mit Huefte senken'],
  plank_jacks: ['Plank jumping jacks', 'Hampelmann im Stuetz'],
  plank_hip_twist: ['Plank hip dips', 'Plank twist', 'Unterarmstuetz mit Huefte drehen'],
  toe_touch_crunch: ['Toe touches', 'Toe reach', 'Zehen tippen Crunch'],
  mountain_climber_slow: ['Slow climbers', 'Langsamer Bergsteiger'],
  bear_plank_hold: ['Bear hold', 'Hover bear', 'Baerenstuetz'],

  // Cardio and jumps
  jumping_jack: ['Hampelmaenner', 'Jumping jacks', 'Jacks', 'Hampelmann'],
  seal_jack: ['Seal jacks', 'Seehund Hampelmann'],
  half_jack: ['Step-out jack', 'Hampelmann ohne Springen'],
  high_knees: ['High knee run', 'Knee drives', 'Kniehebelauf', 'Skipping laufen'],
  marching_high_knees: ['High knee march', 'Marschieren auf der Stelle'],
  butt_kicks: ['Butt kickers', 'Heel flicks', 'Anfersen'],
  jog_in_place: ['Running in place', 'Spot jog', 'Laufen auf der Stelle', 'Joggen auf der Stelle'],
  fast_feet: ['Quick feet', 'Fast feet drill', 'Schnelle Fuesse', 'Tappings'],
  mountain_climber: ['Mountain climbers', 'Climbers', 'Bergsteiger'],
  cross_body_mountain_climber: ['Cross climbers', 'Twisting mountain climber', 'Bergsteiger diagonal'],
  lateral_shuffle: ['Side shuffle', 'Sidestep shuffle', 'Seitwaerts Sidesteps'],
  shadow_boxing: ['Shadowboxing', 'Air boxing', 'Schattenboxen'],
  skaters: ['Skater jumps', 'Skaters', 'Eisschnelllaeufer'],
  burpee: ['Burpees', 'Squat thrust jump', 'Burpee Uebung', 'Liegestuetz Strecksprung'],
  burpee_push_up: ['Push-up burpee', 'Burpee mit Liegestuetz'],
  half_burpee: ['No-jump burpee', 'Halber Burpee'],
  sprawl: ['Sprawls', 'Burpee sprawl', 'Sprawl Uebung'],
  step_back_burpee: ['Walk-out burpee', 'Burpee ohne Springen'],
  squat_jump: ['Squat jumps', 'Jumping squat', 'Strecksprung aus der Kniebeuge', 'Sprungkniebeuge'],
  tuck_jump: ['Knee tuck jump', 'Hocksprung'],
  lunge_jump: ['Lunge jumps', 'Jump lunge', 'Ausfallschritt Sprung', 'Wechselsprung'],
  star_jump: ['Star jumps', 'Sternsprung'],
  broad_jump: ['Standing long jump', 'Weitsprung aus dem Stand'],
  frog_jump: ['Frog jumps', 'Froschsprung'],
  pogo_hops: ['Pogo jumps', 'Ankle hops', 'Fussgelenkspruenge'],
  single_leg_hop: ['One-leg hop', 'Einbeinige Spruenge'],
  lateral_bound: ['Skater bound', 'Side bound', 'Seitlicher Sprung'],
  burpee_tuck_jump: ['Tuck jump burpee', 'Burpee mit Hocksprung'],
  box_jump: ['Box jumps', 'Plyo box jump', 'Kastensprung', 'Box Sprung'],
  box_step_up_fast: ['Step-ups for cardio', 'Schnelles Aufsteigen'],
  burpee_box_jump_over: ['BBJO', 'Burpee box jump', 'Burpee ueber die Box'],
  depth_drop: ['Drop landing', 'Box drop', 'Niedersprung'],
  jump_rope_basic: ['Rope skipping', 'Skipping rope', 'Seilspringen', 'Seil springen'],
  jump_rope_alternate_foot: ['Alternate foot step', 'Seilspringen Laufschritt'],
  jump_rope_high_knees: ['High knee skips', 'Seilspringen Kniehebel'],
  double_under: ['Double unders', 'DU', 'Doppelsprung Seil', 'Doppeldurchschlag'],

  // Mobility and stretches
  neck_rolls: ['Neck circles', 'Nackenkreisen', 'Kopfkreisen'],
  shoulder_rolls: ['Shoulder circles', 'Schulterkreisen'],
  wrist_circles: ['Wrist rotations', 'Handgelenkkreisen'],
  hip_circles: ['Hip rotations', 'Hula hips', 'Hueftkreisen'],
  leg_swings_front: ['Front leg swings', 'Forward leg swings', 'Beinschwingen vor und zurueck'],
  leg_swings_side: ['Lateral leg swings', 'Side leg swings', 'Beinschwingen seitlich'],
  torso_twists: ['Standing twists', 'Rumpfdrehen', 'Oberkoerper drehen'],
  worlds_greatest_stretch: ['WGS', 'Greatest stretch', 'Weltbeste Dehnung'],
  thoracic_open_book: ['Open book stretch', 'Side-lying thoracic rotation', 'Offenes Buch', 'Brustwirbelsaeule Rotation'],
  thread_the_needle: ['Needle stretch', 'Faden einfaedeln'],
  ninety_ninety_switch: ['90 90 switch', 'Ninety ninety', '90 90 Hueftrotation'],
  deep_squat_hold: ['Squat hold', 'Bottom squat hold', 'Tiefe Hocke'],
  ankle_rocks: ['Knee to wall ankle mobility', 'Ankle mobility drill', 'Sprunggelenk Mobilisation'],
  scapular_push_up: ['Scapula push-up', 'Schulterblatt Liegestuetz'],
  wall_slides: ['Wall angels', 'Wall slide', 'Wandengel'],
  hip_airplane: ['Airplane', 'Flugzeug Uebung', 'Hueft Flugzeug'],
  spinal_waves: ['Body wave', 'Spine wave', 'Wirbelsaeulenwelle'],
  jefferson_curl_bodyweight: ['Jefferson curl', 'Segmental roll-down', 'Abrollen Wirbel fuer Wirbel'],
  cossack_shift: ['Side-to-side squat shift', 'Seitliches Gewicht verlagern'],
  glute_bridge_march: ['Marching bridge', 'Beckenheben mit Marschieren'],
  standing_hamstring_stretch: ['Hamstring stretch', 'Beinbeuger Dehnung', 'Hamstring Dehnung'],
  seated_forward_fold: ['Seated hamstring stretch', 'Paschimottanasana', 'Vorbeuge im Sitzen'],
  butterfly_stretch: ['Seated butterfly', 'Schmetterling Dehnung', 'Schmetterlingssitz'],
  frog_stretch: ['Frog pose', 'Frosch Dehnung'],
  lizard_stretch: ['Lizard pose', 'Eidechse'],
  couch_stretch: ['Sofa stretch', 'Couch Dehnung'],
  figure_four_stretch: ['Figure 4 stretch', 'Glute stretch lying', 'Gesaess Dehnung liegend'],
  childs_pose: ['Child pose', 'Balasana', 'Kindhaltung', 'Stellung des Kindes'],
  cobra_stretch: ['Cobra pose', 'Kobra'],
  sphinx_pose: ['Sphinx stretch', 'Sphinx'],
  supine_twist: ['Spinal twist', 'Liegende Drehung', 'Drehsitz liegend'],
  knees_to_chest: ['Double knee to chest', 'Knie zur Brust'],
  happy_baby: ['Happy baby pose', 'Gluecliches Baby'],
  cross_body_shoulder_stretch: ['Cross-arm stretch', 'Shoulder stretch', 'Schulter Dehnung'],
  overhead_triceps_stretch: ['Triceps stretch', 'Trizeps Dehnung'],
  doorway_chest_stretch: ['Chest stretch', 'Pec stretch', 'Brust Dehnung im Tuerrahmen'],
  standing_calf_stretch: ['Calf stretch', 'Waden Dehnung'],
  kneeling_hip_flexor_stretch: ['Hip flexor stretch', 'Half-kneeling hip flexor stretch', 'Hueftbeuger Dehnung'],
  side_bend_stretch: ['Side stretch', 'Seitbeuge', 'Seitliche Dehnung'],
  lat_stretch_wall: ['Lat stretch', 'Latissimus Dehnung'],
  neck_side_stretch: ['Neck stretch', 'Nacken Dehnung'],
  wrist_flexor_stretch: ['Forearm stretch', 'Handgelenk Dehnung', 'Unterarm Dehnung'],
  seated_straddle: ['Straddle stretch', 'Middle split stretch', 'Gratsche', 'Gegraetschte Vorbeuge'],
  standing_forward_fold: ['Toe touch stretch', 'Uttanasana', 'Vorbeuge im Stehen'],
  legs_up_the_wall: ['Viparita karani', 'Beine an die Wand'],
  pretzel_stretch: ['Pretzel', 'Brezel Dehnung'],
  box_breathing: ['Square breathing', '4 4 4 4 breathing', 'Box Atmung', 'Quadratatmung'],
  belly_breathing: ['Belly breaths', 'Bauchatmung', 'Zwerchfellatmung'],

  // Kettlebell
  one_arm_swing: ['One-hand swing', 'One-hand kettlebell swing', 'KB one-arm swing', 'Einarmiger Kettlebell Swing'],
  hand_to_hand_swing: ['Hand switch swing', 'Swing mit Handwechsel'],
  american_swing: ['American kettlebell swing', 'KB American swing', 'Amerikanischer Swing'],
  kettlebell_clean: ['KB clean', 'One-arm kettlebell clean', 'Kettlebell Umsetzen'],
  alternating_clean: ['KB alternating clean', 'Wechselnder Kettlebell Clean'],
  double_clean: ['Double KB clean', 'Kettlebell Clean mit zwei Kugeln'],
  kettlebell_snatch: ['KB snatch', 'Snatch', 'Kettlebell Reissen'],
  half_snatch: ['Kettlebell half snatch', 'KB half snatch', 'Halber Snatch'],
  kettlebell_high_pull: ['KB high pull', 'One-arm high pull', 'Kettlebell Hochziehen'],
  sumo_high_pull: ['KB sumo high pull', 'SDHP', 'Sumo deadlift high pull', 'Sumo Hochziehen'],
  kettlebell_dead_clean: ['KB dead clean', 'Kettlebell Clean vom Boden'],
  kettlebell_press: ['KB press', 'KB military press', 'Kettlebell shoulder press', 'Kettlebell Schulterdruecken'],
  kettlebell_push_press: ['KB push press', 'Kettlebell Stossdruecken'],
  kettlebell_jerk: ['KB jerk', 'Kettlebell Stossen'],
  double_press: ['Double KB press', 'Double kettlebell overhead press', 'Schulterdruecken mit zwei Kettlebells'],
  bottoms_up_press: ['Bottom-up press', 'KB bottoms-up press', 'Bottoms up Druecken'],
  half_kneeling_press: ['Half-kneeling KB press', 'Kniender Kettlebell Druecken'],
  kettlebell_floor_press: ['KB floor press', 'Kettlebell Bodendruecken'],
  kettlebell_halo: ['KB halo', 'Kettlebell Halo Kreisen'],
  overhead_hold: ['KB overhead hold', 'Waiter hold', 'Kettlebell ueber Kopf halten'],
  kettlebell_windmill: ['Windmill', 'KB windmill', 'Windmuehle'],
  turkish_get_up: ['Turkish getup', 'Kettlebell get-up', 'Tuerkisches Aufstehen'],
  half_get_up: ['Half TGU', 'Half Turkish get-up', 'Halbes tuerkisches Aufstehen'],
  goblet_squat: ['Kettlebell squat', 'KB goblet squat', 'Kettlebell goblet squat', 'Goblet Kniebeuge'],
  kettlebell_front_squat: ['KB front squat', 'Racked squat', 'Kettlebell Frontkniebeuge'],
  double_front_squat: ['Double KB front squat', 'Double rack squat', 'Frontkniebeuge mit zwei Kettlebells'],
  kettlebell_sumo_squat: ['KB sumo squat', 'Kettlebell Sumo Kniebeuge'],
  overhead_squat_kb: ['KB overhead squat', 'Single-arm overhead squat', 'Kettlebell Ueberkopf Kniebeuge'],
  kettlebell_thruster: ['KB thruster', 'Kettlebell Thruster Kniebeuge mit Druecken'],
  goblet_reverse_lunge: ['KB goblet lunge', 'Goblet lunge', 'Goblet Ausfallschritt'],
  rack_lunge: ['KB rack lunge', 'Front-rack lunge', 'Kettlebell Ausfallschritt'],
  kettlebell_lateral_lunge: ['KB lateral lunge', 'KB side lunge', 'Kettlebell seitlicher Ausfallschritt'],
  lunge_pass_through: ['KB lunge pass-through', 'Figure eight lunge', 'Ausfallschritt mit Durchreichen'],
  kettlebell_step_up: ['KB step-up', 'Kettlebell Aufsteiger'],
  kettlebell_cossack_squat: ['KB Cossack squat', 'Kettlebell Kosaken Kniebeuge'],
  kettlebell_rdl: ['Kettlebell RDL', 'KB Romanian deadlift', 'Kettlebell rumaenisches Kreuzheben'],
  single_leg_kb_deadlift: ['Single-leg KB RDL', 'KB single-leg deadlift', 'Einbeiniges Kettlebell Kreuzheben'],
  suitcase_deadlift: ['KB suitcase deadlift', 'Koffer Kreuzheben'],
  kettlebell_good_morning: ['KB good morning', 'Kettlebell Guten Morgen'],
  kettlebell_hip_thrust: ['KB hip thrust', 'Kettlebell Hip Thrust Huefte'],
  kettlebell_swing_deadstop: ['Dead-stop KB swing', 'Swing vom Boden'],
  kettlebell_row: ['KB row', 'One-arm kettlebell row', 'Kettlebell Rudern'],
  bent_over_double_row: ['Double KB row', 'Vorgebeugtes Rudern mit zwei Kettlebells'],
  gorilla_row: ['KB gorilla row', 'Gorilla Rudern'],
  kettlebell_upright_row: ['KB upright row', 'Kettlebell aufrechtes Rudern'],
  kettlebell_pullover: ['KB pullover', 'Kettlebell Ueberzuege'],
  kettlebell_curl: ['KB curl', 'Kettlebell biceps curl', 'Kettlebell Bizepscurl'],
  kettlebell_triceps_extension: ['KB triceps extension', 'KB overhead extension', 'Kettlebell Trizepsdruecken'],
  kettlebell_around_the_world: ['Around the body pass', 'KB around the world', 'Kettlebell um den Koerper'],
  kettlebell_figure_eight: ['KB figure 8', 'Figure 8', 'Kettlebell Acht'],
  kettlebell_russian_twist: ['KB Russian twist', 'Russischer Twist mit Kettlebell'],
  kettlebell_sit_up: ['KB sit-up', 'Weighted sit-up', 'Sit-up mit Kettlebell'],
  kettlebell_pass_plank_drag: ['KB plank drag', 'Plank pull-through', 'Kettlebell Ziehen im Stuetz'],
  farmers_carry_kb: ['Farmers carry', 'KB farmer carry', 'Bauernlauf', 'Farmers Walk'],
  suitcase_carry: ['KB suitcase carry', 'One-arm farmer carry', 'Kofferlauf'],
  rack_carry: ['KB rack carry', 'Front rack walk', 'Kettlebell Tragen vor der Brust'],
  overhead_carry: ['KB overhead carry', 'Waiter walk', 'Kellnerlauf'],
  clean_and_press: ['KB clean and press', 'Kettlebell clean and press', 'Umsetzen und Druecken'],
  clean_squat_press: ['KB clean squat press', 'Umsetzen Kniebeuge Druecken'],
  swing_to_goblet_squat: ['Swing squat', 'KB swing to squat', 'Swing mit Goblet Kniebeuge'],
  kettlebell_burpee_deadlift: ['KB burpee deadlift', 'Burpee mit Kreuzheben'],
  kettlebell_man_maker: ['Man maker', 'KB man maker', 'Man Maker Uebung'],

  // Barbell
  back_squat: ['Back squat', 'BB squat', 'Barbell squat', 'Kniebeuge mit Langhantel', 'Langhantel Kniebeuge'],
  front_squat: ['Front squat', 'BB front squat', 'Frontkniebeuge'],
  box_squat: ['BB box squat', 'Kniebeuge auf Box'],
  deadlift: ['Deadlift', 'BB deadlift', 'Kreuzheben', 'Kreuzheben mit Langhantel'],
  sumo_deadlift: ['Sumo DL', 'Sumo Kreuzheben'],
  romanian_deadlift: ['Stiff-leg deadlift', 'SLDL', 'RDL', 'BB RDL', 'Barbell RDL', 'Rumaenisches Kreuzheben', 'Kreuzheben mit gestreckten Beinen'],
  trap_bar_deadlift: ['Trap bar DL', 'Hex bar DL', 'Trap Bar Kreuzheben'],
  good_morning: ['Good morning', 'BB good morning', 'Guten Morgen mit Langhantel'],
  hip_thrust: ['Hip thrust', 'BB hip thrust', 'Hueftstoss', 'Hip Thrust mit Langhantel'],
  barbell_lunge: ['BB lunge', 'Barbell lunge', 'Ausfallschritt mit Langhantel'],
  bench_press: ['Bench', 'BB bench press', 'Bankdruecken', 'Bankdruecken mit Langhantel'],
  incline_bench_press: ['Incline bench', 'Incline barbell press', 'Schraegbankdruecken'],
  close_grip_bench_press: ['CGBP', 'Close-grip bench', 'Enges Bankdruecken'],
  overhead_press: ['Overhead press', 'BB overhead press', 'Standing press', 'Shoulder press', 'Schulterdruecken', 'Schulterdruecken mit Langhantel'],
  push_press: ['Push press', 'BB push press', 'Stossdruecken'],
  barbell_row: ['Barbell row', 'BB row', 'Rudern vorgebeugt', 'Langhantelrudern'],
  t_bar_row: ['T bar row', 'Landmine T-bar row', 'T-Bar Rudern'],
  pendlay_row: ['Pendlay', 'Dead-stop barbell row', 'Pendlay Rudern'],
  barbell_shrug: ['BB shrug', 'Shrugs', 'Schulterheben mit Langhantel'],
  barbell_curl: ['BB curl', 'Straight bar curl', 'Langhantel Curl', 'Bizepscurl mit Langhantel'],
  preacher_curl: ['Scott curl', 'Preacher bench curl', 'Scottcurl'],
  skull_crusher: ['Skullcrusher', 'French press', 'Stirndruecken', 'French Press Trizeps'],
  landmine_press: ['Landmine shoulder press', 'Landmine Druecken'],
  landmine_row: ['Landmine one-arm row', 'Landmine Rudern'],
  power_clean: ['Clean', 'Umsetzen', 'Power Clean Umsetzen'],
  hang_power_clean: ['Hang clean', 'Umsetzen aus dem Hang'],
  power_snatch: ['Barbell snatch', 'Reissen', 'Power Snatch Reissen'],
  barbell_thruster: ['BB thruster', 'Thruster', 'Thruster mit Langhantel'],

  // Dumbbell
  dumbbell_bench_press: ['DB bench press', 'DB bench', 'Kurzhantel Bankdruecken', 'Bankdruecken mit Kurzhanteln'],
  incline_dumbbell_press: ['Incline DB press', 'Incline dumbbell bench press', 'Schraegbankdruecken mit Kurzhanteln'],
  dumbbell_floor_press: ['DB floor press', 'Bodendruecken mit Kurzhanteln'],
  dumbbell_fly: ['DB fly', 'Dumbbell flye', 'Chest fly', 'Fliegende', 'Kurzhantel Fliegende'],
  dumbbell_shoulder_press: ['DB shoulder press', 'DB overhead press', 'Seated dumbbell press', 'Kurzhantel Schulterdruecken'],
  arnold_press: ['Arnold dumbbell press', 'Arnold Druecken'],
  lateral_raise: ['Side raise', 'DB lateral raise', 'Lateral raises', 'Seitheben'],
  front_raise: ['DB front raise', 'Frontheben'],
  rear_delt_fly: ['Reverse fly', 'Bent-over lateral raise', 'Reverse Flys', 'Vorgebeugtes Seitheben'],
  dumbbell_pullover: ['DB pullover', 'Pullover', 'Ueberzuege'],
  dumbbell_row: ['Rudern', 'Kurzhantel Rudern', 'One-arm DB row', 'Single-arm dumbbell row', 'DB row', 'Einarmiges Kurzhantelrudern'],
  chest_supported_row: ['Incline dumbbell row', 'Seal row', 'Rudern auf der Schraegbank'],
  dumbbell_bent_over_row: ['DB bent-over row', 'Vorgebeugtes Kurzhantelrudern'],
  dumbbell_shrug: ['DB shrug', 'Schulterheben mit Kurzhanteln'],
  dumbbell_curl: ['DB curl', 'Curl', 'Bicep curl', 'Bizepscurl', 'Kurzhantel Curl'],
  hammer_curl: ['DB hammer curl', 'Neutral-grip curl', 'Hammercurl'],
  concentration_curl: ['Seated concentration curl', 'Konzentrationscurl'],
  incline_dumbbell_curl: ['Incline curl', 'Schraegbank Curl'],
  overhead_triceps_extension: ['Triceps extension', 'DB overhead triceps extension', 'DB triceps extension', 'Overhead extension', 'Trizepsdruecken ueber Kopf'],
  triceps_kickback: ['DB kickback', 'Triceps kickbacks', 'Trizeps Kickback'],
  wrist_curl: ['Forearm curl', 'DB wrist curl', 'Handgelenkcurl', 'Unterarmcurl'],
  dumbbell_goblet_squat: ['DB goblet squat', 'Goblet Kniebeuge mit Kurzhantel'],
  dumbbell_squat: ['DB squat', 'Kniebeuge mit Kurzhanteln'],
  dumbbell_lunge: ['DB lunge', 'Ausfallschritt mit Kurzhanteln'],
  dumbbell_walking_lunge: ['DB walking lunge', 'Gehende Ausfallschritte mit Kurzhanteln'],
  dumbbell_bulgarian_split_squat: ['DB Bulgarian split squat', 'DB BSS', 'Bulgarische Kniebeuge mit Kurzhanteln'],
  dumbbell_step_up: ['DB step-up', 'Aufsteiger mit Kurzhanteln'],
  dumbbell_rdl: ['DB RDL', 'Dumbbell RDL', 'Rumaenisches Kreuzheben mit Kurzhanteln'],
  dumbbell_single_leg_rdl: ['DB single-leg RDL', 'Einbeiniges Kreuzheben mit Kurzhantel'],
  dumbbell_calf_raise: ['DB calf raise', 'Wadenheben mit Kurzhanteln'],
  dumbbell_thruster: ['DB thruster', 'Thruster mit Kurzhanteln'],
  dumbbell_snatch: ['DB snatch', 'One-arm dumbbell snatch', 'Kurzhantel Reissen'],
  dumbbell_clean_and_press: ['DB clean and press', 'Umsetzen und Druecken mit Kurzhanteln'],
  devil_press: ['Devils press', 'DB devil press', 'Devil Press Uebung'],
  dumbbell_renegade_row: ['DB renegade row', 'Renegade Rudern mit Kurzhanteln'],
  dumbbell_farmers_carry: ['DB farmer carry', 'Dumbbell farmers walk', 'Bauernlauf mit Kurzhanteln'],
  dumbbell_woodchop: ['DB woodchop', 'Holzhacker', 'Holzhacker mit Kurzhantel'],

  // Machines
  leg_press: ['Leg press machine', 'Beinpresse'],
  hack_squat: ['Hack squat machine', 'Hackenschmidt Kniebeuge', 'Hackenschmidt'],
  smith_squat: ['Smith squat', 'Kniebeuge an der Multipresse'],
  leg_extension: ['Leg extensions', 'Quad extension', 'Beinstrecker'],
  lying_leg_curl: ['Hamstring curl', 'Leg curl', 'Prone leg curl', 'Beinbeuger liegend', 'Beinbeuger'],
  seated_leg_curl: ['Seated hamstring curl', 'Beinbeuger sitzend'],
  hip_abduction_machine: ['Abductor machine', 'Hip abduction', 'Abduktoren Maschine'],
  hip_adduction_machine: ['Adductor machine', 'Hip adduction', 'Adduktoren Maschine'],
  standing_calf_raise_machine: ['Machine calf raise', 'Wadenmaschine', 'Wadenheben an der Maschine'],
  glute_kickback_machine: ['Machine glute kickback', 'Gesaessmaschine'],
  back_extension: ['45-degree back extension', 'Rueckenstrecker', 'Hyperextensions'],
  chest_press_machine: ['Machine chest press', 'Seated chest press', 'Brustpresse'],
  shoulder_press_machine: ['Machine shoulder press', 'Schulterpresse'],
  pec_deck: ['Pec fly machine', 'Butterfly', 'Butterfly Maschine'],
  reverse_pec_deck: ['Rear delt machine', 'Reverse fly machine', 'Reverse Butterfly'],
  assisted_dip_machine: ['Assisted dips', 'Dip Maschine mit Unterstuetzung'],
  smith_bench_press: ['Smith bench', 'Bankdruecken an der Multipresse'],
  seated_row_machine: ['Machine row', 'Rudermaschine sitzend', 'Rudern an der Maschine'],
  assisted_pull_up_machine: ['Assisted pull-ups', 'Gravitron', 'Klimmzug mit Unterstuetzung'],
  machine_curl: ['Machine biceps curl', 'Bizepsmaschine'],
  machine_triceps_extension: ['Machine triceps', 'Trizepsmaschine'],
  ab_crunch_machine: ['Machine crunch', 'Bauchmaschine'],

  // Cables
  lat_pulldown: ['Lat pull-down', 'Pulldown', 'Latziehen', 'Latzug'],
  close_grip_pulldown: ['V-bar pulldown', 'Close-grip lat pulldown', 'Enges Latziehen'],
  seated_cable_row: ['Cable row', 'Low row', 'Kabelrudern', 'Rudern am Kabelzug'],
  face_pull: ['Face pulls', 'Rope face pull', 'Face Pull Kabelzug'],
  straight_arm_pulldown: ['Straight-arm lat pulldown', 'Lat prayer', 'Ueberzug am Kabel'],
  cable_fly: ['Cable flye', 'Cable chest fly', 'Kabelzug Fliegende', 'Cable Crossover Brust'],
  triceps_pushdown: ['Triceps pressdown', 'Cable pushdown', 'Trizepsdruecken am Kabel'],
  cable_overhead_triceps_extension: ['Overhead cable extension', 'Trizeps ueber Kopf am Kabel'],
  cable_curl: ['Cable biceps curl', 'Bizepscurl am Kabel'],
  cable_lateral_raise: ['Cable side raise', 'Seitheben am Kabel'],
  cable_woodchop: ['Woodchopper', 'Cable chop', 'Holzhacker am Kabel'],
  pallof_press: ['Anti-rotation press', 'Pallof Druecken'],
  cable_crunch: ['Kneeling cable crunch', 'Rope crunch', 'Crunch am Kabelzug'],
  cable_pull_through: ['Pull-through', 'Pull Through am Kabel'],
  cable_glute_kickback: ['Cable kickback', 'Kickback am Kabelzug'],

  // Cardio machines
  rowing_machine: ['Indoor rowing', 'Rudergeraet', 'Rudern Cardio'],
  stationary_bike: ['Bike', 'Indoor bike', 'Ergometer', 'Fahrradergometer', 'Spinning'],
  assault_bike: ['Echo bike', 'Airbike'],
  treadmill_run: ['Treadmill', 'Laufband', 'Laufband laufen'],
  incline_walk: ['Incline walking', 'Hill walk', 'Gehen auf dem Laufband mit Steigung'],
  elliptical: ['Elliptical trainer', 'Crosstrainer'],
  stair_climber: ['Stairmaster', 'Stair stepper', 'Treppensteiger', 'Stepper'],
  ski_erg: ['SkiErg', 'Ski machine', 'Skiergometer'],

  // Pull-up bar and dips
  pull_up: ['Pullup', 'Pull-ups', 'Overhand pull-up', 'Klimmzug', 'Klimmzuege'],
  chin_up: ['Chinup', 'Chin-ups', 'Underhand pull-up', 'Klimmzug im Untergriff'],
  neutral_grip_pull_up: ['Hammer-grip pull-up', 'Parallel-grip pull-up', 'Klimmzug im Neutralgriff'],
  negative_pull_up: ['Pull-up negative', 'Negative Klimmzuege', 'Negativer Klimmzug'],
  band_assisted_pull_up: ['Assisted pull-up with band', 'Klimmzug mit Band'],
  scapular_pull_up: ['Scapula pull-up', 'Scap pull-up', 'Schulterblatt Klimmzug'],
  dead_hang: ['Bar hang', 'Passive hang', 'Haengen an der Stange', 'Totes Haengen'],
  flexed_arm_hang: ['Chin-over-bar hold', 'Bent-arm hang', 'Klimmzug halten'],
  hanging_knee_raise: ['Hanging knee tuck', 'Knieheben haengend'],
  hanging_leg_raise: ['HLR', 'Hanging straight leg raise', 'Beinheben haengend'],
  toes_to_bar: ['T2B', 'TTB', 'Zehen zur Stange'],
  inverted_row: ['Ring row', 'Supine row', 'Rudern am Reck', 'Australische Klimmzuege'],
  muscle_up: ['Bar muscle-up', 'Muscle up', 'Muscle-Up Reck'],
  dip: ['Dips', 'Chest dip', 'Barrenstuetz', 'Dips am Barren'],
  negative_dip: ['Dip negative', 'Negative Dips'],
  support_hold: ['Dip support hold', 'Top dip hold', 'Stuetz am Barren'],

  // Bands
  band_pull_apart: ['Pull-apart', 'Band pull apart', 'Band auseinanderziehen'],
  band_face_pull: ['Banded face pull', 'Face Pull mit Band'],
  band_row: ['Banded row', 'Resistance band row', 'Rudern mit Band'],
  band_lat_pulldown: ['Banded lat pulldown', 'Latziehen mit Band'],
  band_chest_press: ['Banded chest press', 'Brustdruecken mit Band'],
  band_overhead_press: ['Banded shoulder press', 'Schulterdruecken mit Band'],
  band_curl: ['Banded curl', 'Resistance band curl', 'Bizepscurl mit Band'],
  band_triceps_extension: ['Banded triceps extension', 'Trizepsdruecken mit Band'],
  band_lateral_walk: ['Banded side walk', 'Lateral band walk', 'Seitwaerts gehen mit Band'],
  band_glute_bridge: ['Band glute bridge', 'Mini band glute bridge', 'Beckenheben mit Band'],
  band_good_morning: ['Banded good morning', 'Guten Morgen mit Band'],
  band_dislocates: ['Band pass-through', 'Shoulder pass-through', 'Schulterkreisen mit Band'],
  band_squat: ['Banded squat', 'Resistance band squat', 'Kniebeuge mit Band'],

  // Medicine ball, ab wheel, stability ball
  wall_ball: ['Wall balls', 'Wallball', 'Medizinball an die Wand'],
  med_ball_slam: ['Slam ball', 'Med ball slam', 'Medizinball Slam', 'Medizinball werfen'],
  med_ball_chest_pass: ['Chest pass', 'Med ball chest throw', 'Medizinball Brustpass'],
  med_ball_rotational_throw: ['Rotational med ball throw', 'Side throw', 'Medizinball Rotationswurf'],
  med_ball_russian_twist: ['Med ball Russian twist', 'Russischer Twist mit Medizinball'],
  ab_wheel_rollout: ['Ab rollout', 'Ab roller', 'Rollout', 'Bauchroller', 'Bauchrad'],
  stability_ball_crunch: ['Swiss ball crunch', 'Exercise ball crunch', 'Gymnastikball Crunch'],
  stability_ball_hamstring_curl: ['Swiss ball leg curl', 'Ball leg curl', 'Beinbeuger mit Gymnastikball'],
  stability_ball_pike: ['Swiss ball pike', 'Ball pike', 'Pike auf dem Gymnastikball'],
  stir_the_pot: ['Swiss ball stir the pot', 'Topf umruehren', 'Ruehren auf dem Ball'],
};
